import { ChangeDetectionStrategy, Component, signal, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { NavigationService } from '../navigation.service';
import { NavItem } from '../nav-model';

@Component({
  selector: 'myabvv-bottom-bar',
  standalone: true,
  templateUrl: './bottom-bar.component.html',
  styleUrl: './bottom-bar.component.css',
  imports: [RouterLink, RouterLinkActive, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomBarComponent {
  private navigation = inject(NavigationService);

  readonly items = signal<NavItem[]>([]);
  constructor() {
    this.items.set(this.navigation.getBottomBarItems());
  }
}
